import { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import "./Fluide.css";
import withAuth from "../../components/withAuth";
import Typography from "@mui/material/Typography";
import SwipeableViews from "react-swipeable-views";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { withStyles } from "@mui/styles";
import QRCodeTab from "../../components/Fluide/QRCodeTab";
import ManualSearchTab from "../../components/Fluide/ManualSearchTab";
import MyBottlesTab from "../../components/Fluide/MyBottlesTab";
import LiquidBottleFound from "./LiquidBottleFound";
import {
    liquidBottleFetchData,
    clearLiquidBottle,
    getLiquidBottlesAssignedToMe,
} from "../../redux/liquidBottles/liquidBottlesActions";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button/Button";
import DialogActions from "@mui/material/DialogActions";
import ModalButtonOption from "../../components/Modal/ModalButtonOption";
import ValidateIcon from "@mui/icons-material/Check";
import SearchIcon from "@mui/icons-material/Search";
import { getSearchHistoryType, getSearchHistoryLines } from "../../redux/searchHistory/searchHistoryActions";
import { LIQUID_BOTTLE_CODE } from "../../redux/searchHistory/searchHistoryConstants";

function TabContainer({ children, dir }) {
    return (
        <Typography component="div" dir={dir}>
            {children}
        </Typography>
    );
}

const styles = () => ({
    root: {
        flexGrow: 1,
        justify: "center",
    },
    grid: {
        width: "100%",
        margin: 0,
        textAlign: "center",
    },
    icon: {
        fontSize: 48,
        display: "block",
        width: "48px",
        height: "48px",
        marginLeft: "auto",
        marginRight: "auto",
    },
});

class Fluide extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTab: 0,
            openChoiceModal: false,
        };

        this.props.getSearchHistoryLines(getSearchHistoryType(LIQUID_BOTTLE_CODE));
    }

    componentDidMount() {
        this.handleClearLiquidBottle();
    }

    handleClearLiquidBottle() {
        this.props.clearLiquidBottle();

        if (this.props.modalMode) this.props.cancelVisualizingLiquidBottle();
    }

    searchLiquidBottle(serialNumber) {
        if (!this.props.modalMode) {
            this.props.liquidBottleFetchData(serialNumber);
            return;
        }

        this.setState({
            openChoiceModal: true,
            serialNumber,
        });
    }

    visualizeLiquidBottle() {
        this.props.liquidBottleFetchData(this.state.serialNumber);
        this.props.visualizeLiquidBottle(this.state.serialNumber);
        this.closeChoicesModal();
    }

    selectLiquidBottle() {
        this.props.selectLiquidBottle(this.state.serialNumber);
        this.closeChoicesModal();
    }

    closeChoicesModal() {
        this.setState({
            openChoiceModal: false,
            serialNumber: "",
        });
    }

    handleChange = (event, value) => {
        this.setState({ selectedTab: value });
    };

    handleChangeIndex = (index) => {
        this.setState({ selectedTab: index });
    };

    render() {
        const { classes } = this.props;
        let element;

        if (this.props.liquidBottle) element = <LiquidBottleFound />;
        else
            element = (
                <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-margin without-side-padding">
                    <AppBar position="static" color="default">
                        <Tabs
                            value={this.state.selectedTab}
                            onChange={this.handleChange}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="fullWidth"
                        >
                            <Tab label="QR Code" />
                            <Tab label="Saisie manuelle" />
                            <Tab label="Mes bouteilles" />
                        </Tabs>
                    </AppBar>
                    <SwipeableViews axis="x" index={this.state.selectedTab} onChangeIndex={this.handleChangeIndex}>
                        <TabContainer>
                            <QRCodeTab searchLiquidBottle={this.searchLiquidBottle.bind(this)} />
                        </TabContainer>
                        <TabContainer className="col-lg-12 col-md-12 col-sm-12 col-12">
                            <ManualSearchTab searchLiquidBottle={this.searchLiquidBottle.bind(this)} />
                        </TabContainer>
                        <TabContainer className="col-lg-12 col-md-12 col-sm-12 col-12">
                            <MyBottlesTab searchLiquidBottle={this.searchLiquidBottle.bind(this)} />
                        </TabContainer>
                    </SwipeableViews>
                    <Dialog open={this.state.openChoiceModal} aria-labelledby="form-dialog-title">
                        <DialogTitle id="form-dialog-title">{"Bouteille: " + this.state.serialNumber}</DialogTitle>
                        <DialogContent className="without-side-padding">
                            <ModalButtonOption
                                name={"Sélectionner"}
                                onClick={this.selectLiquidBottle.bind(this)}
                                icon={<ValidateIcon className={classes.icon} />}
                            />
                            <ModalButtonOption
                                name={"Visualiser"}
                                onClick={this.visualizeLiquidBottle.bind(this)}
                                icon={<SearchIcon className={classes.icon} />}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button
                                className="button red-button"
                                onClick={this.closeChoicesModal.bind(this)}
                                color="primary"
                            >
                                Annuler
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            );

        return (
            <div className={classes.root}>
                <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                    <div className={classes.grid}>{element}</div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        liquidBottle: state.liquidBottle,
        activeUser: state.activeUser,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        liquidBottleFetchData: (bottleCode) => dispatch(liquidBottleFetchData(bottleCode)),
        clearLiquidBottle: () => dispatch(clearLiquidBottle()),
        getSearchHistoryLines: (type) => dispatch(getSearchHistoryLines(type)),
        getLiquidBottlesAssignedToMe: (user, allMyLiquidBottles) =>
            dispatch(getLiquidBottlesAssignedToMe(user, allMyLiquidBottles)),
    };
};

export default compose(withAuth, withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(Fluide);
